import axios, { AxiosInstance } from 'axios';
import { get } from 'lodash';
import { userRefresh } from './api';
import { getAccessToken, getRefreshToken } from './storage';

export const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const checkoutInstance = axios.create({
  baseURL: process.env.REACT_APP_CHECKOUT_BASE_URL,
});

let onExpireCallback = () => {
  return;
};

let showErrorPage: () => void;

export const setRequestHeaders = (accessToken: string): void => {
  apiInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  checkoutInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
};

const onError = async (instance: AxiosInstance, e: any) => {
  const originalRequest = e.config;
  if (e.response) {
    if (await onRefreshToken(e)) {
      originalRequest.headers.Authorization = `Bearer ${getAccessToken()}`;
      return instance(originalRequest);
    }
    e.message = `[${e.config.url}:${e.response.status}] ${get(e, 'response.data.message', e.message)}`;
    console.error(e);
    if (e.response.status >= 500) {
      showErrorPage();
    }
  }
  return Promise.reject(e);
};

const onRefreshToken = async (e: any) => {
  if (e.config.url === '/user/refresh') {
    onExpireCallback();
    return false;
  }
  if (e.response.status === 401 || e.code === 'ACCESS_TOKEN_EXPIRED') {
    await userRefresh({
      accessToken: getAccessToken(),
      refreshToken: getRefreshToken(),
    });
    return true;
  }
  return false;
};

export const setExpireCallback = (cb: () => void): void => {
  onExpireCallback = cb;
};

export const setShow500Page = (errorPage: () => void): void => {
  showErrorPage = errorPage;
};

apiInstance.interceptors.request.use(
  (config) => {
    if (!config.headers.common.Authorization && getAccessToken()) {
      config.headers.common.Authorization = `Bearer ${getAccessToken()}`;
    }
    return config;
  },
  (e) => {
    // Do something with request error
    return Promise.reject(e);
  },
);

apiInstance.interceptors.response.use(
  async (res) => {
    if (res.status === 200) {
      return res.data;
    }
  },
  (e) => onError(apiInstance, e),
);

checkoutInstance.interceptors.request.use(
  (config) => {
    if (!config.headers.common.Authorization && getAccessToken()) {
      config.headers.common.Authorization = `Bearer ${getAccessToken()}`;
    }
    return config;
  },
  (e) => {
    // Do something with request error
    return Promise.reject(e);
  },
);

checkoutInstance.interceptors.response.use(
  async (res) => {
    if (res.status === 200) {
      return res.data;
    }
  },
  (e) => onError(apiInstance, e),
);
